import { createContext } from "react";
import { reviewerInitialState } from "./reviewerInitialState";


const ReviewerContext = createContext(reviewerInitialState)

export default ReviewerContext